import { WprBaseViewCore } from './WprBaseViewCore';
import { WprControlInfoMap } from './control/map/WprControlInfoMap';
import { WprControlInfo } from './control/WprControlInfo';
import { WprBaseViewMode } from '../mode/WprBaseViewMode';
import { WprBaseViewMultiMode } from '../mode/WprBaseViewMultiMode';
import { WprMultiMode } from '../mode/WprMultiMode';
import { WprKeyValue } from '../model/WprKeyValue';
import { WprKeyValueMap } from '../model/WprKeyValueMap';
import { WprControRefreshMap } from './control/map/WprControRefreshMap';
import { WprReflectUtil } from '../util/WprReflectUtil';
import { WprBaseSubView } from './WprBaseSubView';
import { WprActionInfo } from '../action/WprActionInfo';
import { WprViewError } from '../component/controls/WprViewError';
import { WprBaseScopeInfo } from '../scope/WprBaseScopeInfo';
import { WprScopeUpdatePropertyInfo } from '../scope/WprScopeUpdatePropertyInfo';
import { WprBaseGlobalScopeInfo } from '../scope/WprBaseGlobalScopeInfo';
import { WprBaseDIManage } from './di/WprBaseDIManage';
import { WprBaseModeComponent } from '../component/controls/WprBaseModeComponent';
import { WprBaseViewCoreComponent } from './component/WprBaseViewCoreComponent';
import { WprRowInfo } from '../component/props/WprRowInfo';
import { WprSwitch } from '../component/route/WprSwitch';

/**
 * ビュー情報基本クラス
 */
export abstract class WprBaseViewInfo extends WprBaseViewCore {
	// private 変数  ------------------------------------------------------------
	private m_Name: string										= null;									// ビュー名称
	private m_IsMount: boolean 									= false;								// なぜか2個作られてエラーになる現象を回避するために使用する
	private m_IsScopeInit: boolean 								= false;								// スコープ初期化フラグ
	private m_ControlInfoMap: WprControlInfoMap					= new WprControlInfoMap();				// コントロールマップ
	private m_Component: WprBaseViewCoreComponent<any>			= null;									// ビューコンポーネント情報
	private m_ViewDataMap: Map<string, any>						= new Map<string, any>();				// ビューデータマップ
	private m_ViewModeDataMap: Map<string, any>					= new Map<string, any>();				// ビューモードマップ
	private m_KeyValueMap: Map<string, WprKeyValueMap>			= new Map<string, WprKeyValueMap>();	// KeyValueリストマップ
	private m_SubViewMap: Map<string, WprBaseSubView> 			= new Map<string, WprBaseSubView>();	// サブビュー情報マップ
	private m_UpdateProList: WprScopeUpdatePropertyInfo[] 		= new Array();							// スコープ更新プロパティ情報リスト
	private m_GlobalScopeInfo: WprBaseGlobalScopeInfo			= null;									// グローバルスコープ情報
	private m_UpdateGlobalProList: WprScopeUpdatePropertyInfo[]	= new Array();							// グローバルスコープ更新プロパティ情報リスト
	private m_ModeComponentList: WprBaseModeComponent<any>[]	= new Array();							// モードコンポーネントリスト
	private m_ResizeEvent: boolean								= true;									// リサイズイベントフラグ
	private m_ScrollEvent: boolean								= true;									// スクロールイベントフラグ
	private m_IsRouteView: boolean								= true;									// ルートビューフラグ(ルートとして使用しない場合はfalse)
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** ビュー名称 */
	public get name(): string 								{ return this.m_Name; 				}
	/** マウントフラグ */
	public get isMount(): boolean 							{ return this.m_IsMount; 			}	public set isMount(isMount: boolean) { this.m_IsMount = isMount; }
	/** 親ビュー情報 */
	public get viewInfo(): WprBaseViewInfo 					{ return this; 						}
	/** コントロールマップ */
	public get controlInfoMap(): WprControlInfoMap 			{ return this.m_ControlInfoMap; 	}
	/** サブビュー情報マップ */
	public get subViewMap(): Map<string, WprBaseSubView> 	{ return this.m_SubViewMap; 		}
	/** グローバルスコープ情報 */	
	public get globalScopeInfo(): WprBaseGlobalScopeInfo 	{ return this.m_GlobalScopeInfo; 	}	public set globalScopeInfo(sinfo: WprBaseGlobalScopeInfo) { this.m_GlobalScopeInfo = sinfo;		}
	/** ビュープロパティ */	
	public get props(): any 								{ return this.m_Component.props; 	}
	/** ルートビューフラグ */	
	public get isRouteView(): boolean 						{ return this.m_IsRouteView; 		}	public set isRouteView(isRoute: boolean) 	{ this.m_IsRouteView = isRoute;		}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor(name: string) {
		super(name);
		this.m_Name = name;
	}
	// --------------------------------------------------------------------------

	// public メソッド  ----------------------------------------------------------
	/**
	 * 初期化処理
	 */
	public initialize(): void {
		try {
			this.initSubViewInfo();
			this.registerConfig();
			this.registerAction();
			this.m_SubViewMap.forEach((subView, key, map) => {
				subView.registerConfig();
				subView.registerAction();
			});
			this.setControlList();
			this.execInjection();
			this.initViewModeInfo();
			this.initExtentionInfo();
			this.m_SubViewMap.forEach((subView, key, map) => {
				subView.execInjection();
				subView.initViewModeInfo();
				subView.initExtentionInfo();
			});
		}
		catch (ex) {
			this.addErrorLog(`ビューの初期化で例外が発生しました。[${this.objectName}]`, ex);
		}
		finally {
			// this.FW.view.addViewInfo(this);
		}
	}

	/**
	 * ビュー表示処理
	 */
	public showView(): void {
		this.startWindowEvent();
		this.setScopeInfo();
		// const dialogRef = this.FW.view.getDialogRef();
		this.FW.view.addViewInfo(this);
		window.setTimeout(this.scroll.bind(this), 10);
		this.onShowView();
		this.onEndShowView();
		/* ATODE
		if (dialogRef != null)
		this.setDialogRef(dialogRef);
		*/
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.onShowView();
			/* ATODE
			if (dialogRef != null)
			this.setDialogRef(dialogRef);
			*/
		});
		if (this.getDocumentTitle() != null)
			document.title = this.getDocumentTitle();
		this.showMode();
		if (this.FW.view.startValidate)
			this.checkValidate(this.FW.view.startValidate, true, false, true);
	}

	/**
	 * 終了処理
	 */
	public terminate(): void {
		this.stopWindowResizeEvent();
		this.stopWindowScrollEvent();
		/* ATODE
		this.clearTableInfo();
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.clearTableInfo();
		});
		*/
		this.FW.view.deleteViewInfo(this);
	}
	// --------------------------------------------------------------------------

	// virtual メソッド  ---------------------------------------------------------
	/**
	 * スコープ情報取得
	 * @returns スコープ情報
	 */
	public getScopeInfo(): WprBaseScopeInfo {
		return null;
	}

	/**
	 * ビュースコープ通知受信処理
	 * @param notifyName 通知名
	 * @param info 通知情報
	 */
	public onNotifyScopeView(notifyName: string, info: any): void {
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.onNotifyScopeView(notifyName, info);
		});
	}

	/**
	 * ウインドウリサイズ通知
	 * @param width 幅
	 * @param height 高さ
	 */
	public onResizeWindow(width: number, height: number): void {
		this.stopWindowResizeEvent();
	}

	/**
	 * ウインドウスクロール通知
	 * @param pageXOffset Xオフセット
	 * @param pageYOffset Yオフセット
	 */
	public onScrollWindow(pageXOffset: number, pageYOffset: number): void {
		this.stopWindowScrollEvent();
	}

	/**
	 * ドキュメントタイトル取得
	 * @returns ドキュメントタイトル
	 */
	public getDocumentTitle() : string {
		return null;
	}

	/**
	 * スクロール処理
	 */
	public scroll(): void {
		window.scrollTo(0, 0);
	}
	// --------------------------------------------------------------------------

	// override メソッド  -------------------------------------------------------
	/**
	 * モデル更新処理
	 * @param name コントロール名称
	 */
	public refreshModel(name?: string): void {
		if (name === undefined)
			this.m_ControlInfoMap.refreshModel(this, '@@all');
		else
			this.m_ControlInfoMap.refreshModel(this, name);
		this.refreshListModel();
		this.updateMode();
		this.refreshReadOnlyControl(name);
	}

	/**
	 * View(FormControlの値)更新処理
	 * @param name コントロール名称
	 */
	public refreshView(name?: string): void {
		if (name === undefined)
			this.m_ControlInfoMap.refreshView(this, '@@all');
		else
			this.m_ControlInfoMap.refreshView(this, name);
		this.refreshListView();
		this.updateMode();
		this.refreshReadOnlyControl(name);
	}

	/**
	 * コントロール値変更処理
	 * @param name コントロール名
	 * @param val 値
	 */
	public changeValue(name: string, val: any): void {
		super.changeModeValue(name, val);
		super.changeExtentionValue(name, val);
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.changeModeValue(name, val);
			subView.changeExtentionValue(name, val);
		});
	}

	/**
	 * リストコントロール値変更処理
	 * @param name コントロール名
	 * @param row 行データ
	 * @param val 値
	 */
	public changeListValue(name: string, row: any, val: any): void {
		super.changeModeValue(name, val);
		// super.changeExtentionValue(name, val);
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.changeModeValue(name, val);
			// subView.changeExtentionValue(name, val);
		});
	}

	/**
	 * ビューモード変更処理
	 * @param mode モード情報
	 * @param oldMode 古いモード
	 * @param newMode 新しいモード
	 */
	public changeViewMode(mode: WprBaseViewMode, oldMode: string, newMode: string): void {
		super.changeMode(mode, oldMode, newMode);
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.changeMode(mode, oldMode, newMode);
		});
		this.setViewModeData(mode.name, newMode);
	}

	/**
	 * 複数ビューモード変更処理
	 * @param oldMode 変更前モード
	 * @param newMode 変更後モード
	 */
	public changeViewMultiMode(mode: WprBaseViewMultiMode, oldMode: WprMultiMode, newMode: WprMultiMode): void {
		super.changeMultiMode(mode, oldMode, newMode);
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.changeMultiMode(mode, oldMode, newMode);
		});
		this.setViewModeData(mode.name, newMode.getModeList());
	}

	/**
	 * ビューデータ設定処理
	 * @param name: ビューデータ名
	 * @param value: ビューデータ
	 */
	public setViewData(name: string, value: any): void {
		this.m_ViewDataMap.set(name, value);
		if (this.isMount === false)
			return;
		this.m_Component.setState({
			data: this.getViewDataState()
		});
	}

	/**
	 * ビューデータ取得処理
	 * @param name ビューデータ名
	 * @returns ビューデータ
	 */
	public getViewData(name: string): any {
		if (this.m_ViewDataMap.has(name) === true)
			return this.m_ViewDataMap.get(name);
		return null;
	}

	/**
	 * ビューモード設定処理
	 * @param name: ビューモード名
	 * @param mode モード
	 * @returns falseの場合、モードは変化がない
	 */
	public setViewMode(name: string, mode: string): boolean {
		if (this.checkModeName(name) === true) {
			this.addErrorLog(`setViewMode：ビューモード名が重複しています。[${name}]`);
			return false;
		}
		return this.setViewModeData(name, mode);
	}

	/**
	 * ビューモード取得処理
	 * @param name ビューモード名
	 * @returns ビューモード
	 */
	public getViewMode(name: string): any {
		if (this.m_ViewModeDataMap.has(name) === true)
			return this.m_ViewModeDataMap.get(name);
		return null;
	}

	/**
	 * View(FormControlの値)クリア処理
	 * @param name コントロール名称
	 */
	public clearView(name?: string): void {
		if (name === undefined)
			this.m_ControlInfoMap.clearValue(this, '@@all');
		else
			this.m_ControlInfoMap.clearValue(this, name);
		this.clearListValue();
		this.setInputErrorList(null);
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.setInputErrorList(null);
		});
		this.updateMode();
	}

	/**
	 * 入力状態取得
	 * @param name コントロール名称
	 * @return trueの場合、入力済みでエラーなし
	 */
	public isInput(name?: string): boolean {
		if (name === undefined) {
			if (this.m_ControlInfoMap.isInput(this, '@@all') === false)
				return false;
		}
		else {
			if (this.m_ControlInfoMap.isInput(this, name) === false)
				return false;
		}
		return this.isInputList();
	}

	/**
	 * コントロール情報取得処理
	 * @param name コントロール名
	 * @param listName リスト名
	 * @param index 行インデクス
	 * @returns コントロール情報
	 */
	public getControlInfo(name: string, listName?: string, index?: number): WprControlInfo {
		let cinfo = super.getControlInfo(name, listName, index);
		if (cinfo == null) {
			this.m_SubViewMap.forEach((subView, key, map) => {
				if (cinfo == null)
					cinfo = subView.getControlInfo(name, listName, index);
			});
		}
		/*
		if (cinfo != null && index) {
			if (cinfo instanceof WprListControlInfo) {
				const lcinfo = cinfo as WprListControlInfo;
				lcinfo.setRowIndex(index);
				return lcinfo.getRowControlInfo();
			}
		}
		*/
 		return cinfo;
	}

	/**
	 * アクション情報取得
	 * @param controlName コントロール名
	 * @param listName リスト名
	 * @return アクション情報
	 */
	public getActionInfo(controlName: string, listName?: string): WprActionInfo {
		let ainfo = super.getActionInfo(controlName, listName);
		if (ainfo == null) {
			this.m_SubViewMap.forEach((subView, key, map) => {
				if (ainfo == null)
					ainfo = subView.getActionInfo(controlName, listName);
			});
		}
 		return ainfo;
	}

	/**
	 * ロストフォーカスアクション情報取得
	 * @param controlName コントロール名
	 * @param listName リスト名
	 * @return アクション情報
	 */
	public getBlurActionInfo(controlName: string, listName?: string): WprActionInfo {
		const aname = `${controlName}@@blur`;
		let ainfo = super.getActionInfo(aname, listName);
		if (ainfo == null) {
			this.m_SubViewMap.forEach((subView, key, map) => {
				if (ainfo == null)
					ainfo = subView.getActionInfo(aname, listName);
			});
		}
		 return ainfo;
	}

	/**
	 * ビューエラー情報登録処理
	 * @param viewError ビューエラー情報
	 * @param subView サブビュー名
	 */
	public addViewErrorControl(viewError: WprViewError, subView?: string): void {
		if (!subView)
			super.addViewErrorControl(viewError);
		else if (this.m_SubViewMap.has(subView) === true)
			this.m_SubViewMap.get(subView).addViewErrorControl(viewError);
		else
			this.addErrorLog(`addViewErrorControl：SubView名に誤りがあります。[${subView}]`);
	}

	/**
	 * スコープモデル設定処理
	 * @param name モデル名称
	 * @param model モデル
	 */
	public setScopeModel(name: string, model: any): void {
		if (this.getScopeInfo() != null)
			this.getScopeInfo().setScopeModel(name, model);
		else
			this.addErrorLog('setScopeModel: WprBaseScopeViewInfo<T>を継承する必要があります。');
	}

	/**
	 * スコープモード設定処理
	 * @param name モード名称
	 * @param mode モード
	 * @returns falseの場合、モードは変化がない
	 */
	public setScopeMode(name: string, mode: any): boolean {
		if (this.getScopeInfo() != null) {
			return this.getScopeInfo().setScopeMode(name, mode);
		}
		else {
			this.addErrorLog('setScopeMode: WprBaseScopeViewInfo<T>を継承する必要があります。');
			return false;
		}
	}

	/**
	 * スコープモード取得処理
	 * @param name スコープモード名
	 * @returns スコープモード
	 */
	public getScopeMode(name: string): any {
		if (this.getScopeInfo() != null)
			return this.getScopeInfo().getScopeMode(name);
		this.addErrorLog('getScopeMode: WprBaseScopeViewInfo<T>を継承する必要があります。');
		return null;
	}

	/**
	 * グローバルスコープモデル設定処理
	 * @param name モデル名称
	 * @param model モデル
	 * @returns falseの場合、モードは変化がない
	 */
	public setGlobalScopeModel(name: string, model: any): void {
		if (this.globalScopeInfo != null)
			this.globalScopeInfo.setGlobalScopeModel(name, model);
		else
			this.addErrorLog('setGlobalScopeModel: グローバルスコープが登録されていません。');
	}

	/**
	 * グローバルモード設定処理
	 * @param name モード名称
	 * @param mode モード
	 * @returns falseの場合、モードは変化がない
	 */
	public setGlobalMode(name: string, mode: any): boolean {
		if (this.globalScopeInfo != null)
			return this.globalScopeInfo.setGlobalScopeMode(name, mode);
		else
			this.addErrorLog('setGlobalScopeMode: グローバルスコープが登録されていません。');
	}

	/**
	 * グローバルモード取得処理
	 * @param name モード名
	 * @returns モード
	 */
	public getGlobalMode(name: string): any {
		if (this.globalScopeInfo != null)
			return this.globalScopeInfo.getScopeMode(name);
		this.addErrorLog('getGlobalMode: グローバルスコープが登録されていません。');
		return null;
	}

	/**
	 * アクションチェック処理
	 * @param name アクション名
	 * @returns falseの場合はアクションは登録されていない
	 */
	public checkAction(action: string): boolean {
		let ret = super.checkAction(action);
		if (ret === false) {
			this.m_SubViewMap.forEach((subView, key, map) => {
				if (ret === false)
					ret = subView.checkAction(action);
			});
		}
		return ret;
	}

	/**
	 * モードチェック
	 * @param mode モード
	 * @returns trueの場合、モードは含まれている
	 */
	public checkMode(mode: string): boolean {
		let modeName;
		if (mode.includes('.') === true) {
			const list = mode.split('.');
			modeName = list[0].trim();
			mode = list[1].trim();
		}
		if (this.checkComponentMode(modeName, mode) === true ||
			this.checkViewModeData(modeName, mode) === true)
			return true;
		return false;
	}

	/**
	 * サービスエラー通知処理
	 * @param url URL
	 * @param status ステータス
	 * @param message エラーメッセージ 
	 * @param error エラー情報
	 */
	public onServiceError(url: string, status: string, message: string, error?: Error): void {
	}

	/**
	 * 次のPathに移動する
	 * @param path 移動するパス
	 * @param isValid バリデーション実行フラグ
	 */
	public pushPath(path: string, isValid?: boolean): void {
		if (this.props.match) {
			this.props.history.push(path);
			if (isValid === true)
				this.FW.view.startValidate = 'pushPath';
			else
				this.FW.view.startValidate = null;
		}
		else {
			this.addErrorLog(`pushPath：withRouterではないViewからは実行できません。[${path}]`);
		}
	}

	/**
	 * 前のPathに戻る
	 * @param isValid バリデーション実行フラグ
	 */
	public goBack(isValid?: boolean): void {
		if (this.props.match) {
			this.props.history.goBack();
			if (isValid === true)
				this.FW.view.startValidate = 'goBack';
			else
				this.FW.view.startValidate = null;
		}
		else {
			this.addErrorLog('goBack：withRouterではないViewからは実行できません。');
		}
	}
	// --------------------------------------------------------------------------

	// public メソッド  ---------------------------------------------------------
	/**
	 * コンポーネント設定処理&
	 * @param component コンポーネント
	 */
	public setComponent(component: WprBaseViewCoreComponent<any>): void {
		this.m_Component = component;
	}

	/**
	 * スコープモデルの変更チェック処理
	 */
	public checkScopeModelValue(): void {
		if (this.getScopeInfo() != null)
			this.getScopeInfo().checkModelValue();
		if (this.globalScopeInfo != null)
			this.globalScopeInfo.checkModelValue();
	}

	/**
	 * モデル値チェック通知
	 * @param name モデル名
	 * @param model モデル
	 * @param isGlobal グローバルフラグ
	 * @param prop プロパティ名
	 */
	public onCheckModelValue(name: string, model: any, isGlobal: boolean, prop?: string): void {
		super.updateModel(name, model, isGlobal, prop);
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.updateModel(name, model, isGlobal, prop);
		});
	}

	/**
	 * DI用コントロール情報マップ取得
	 * @returns DI要コントロール情報マップ
	 */
	public getDIControlMap(): WprControRefreshMap {
		return this.m_ControlInfoMap.get('@@all');
	}

	/**
	 * スコープモデル更新時にチェックするプロパティをチェックする
	 * @param obj 対象オブジェクト
	 * @param name モデル名
	 * @param prop プロパティ名
	 */
	public setScopeModelUpdateProperty(obj: WprBaseDIManage, name: string, prop: string): void {
		if (this.getScopeInfo() != null)
			this.m_UpdateProList.push(new WprScopeUpdatePropertyInfo(obj, name, prop));
	}

	/**
	 * グローバルスコープモデル更新時にチェックするプロパティをチェックする
	 * @param obj 対象オブジェクト
	 * @param name モデル名
	 * @param prop プロパティ名
	 */
	public setGlobalScopeModelUpdateProperty(obj: WprBaseDIManage, name: string, prop: string): void {
		this.m_UpdateGlobalProList.push(new WprScopeUpdatePropertyInfo(obj, name, prop));
	}

	/**
	 * スコープ更新プロパティ設定
	 */
	public setScopeUpdateProperty() {
		if (this.m_IsScopeInit === false) {
			this.m_IsScopeInit = true;
			if (this.getScopeInfo() != null) {
				for (const uinfo of this.m_UpdateProList)
					this.getScopeInfo().setUpdateProperty(uinfo);
			}
			if (this.globalScopeInfo != null) {
				for (const uinfo of this.m_UpdateGlobalProList)
					this.globalScopeInfo.setUpdateProperty(uinfo);
			}
		}
	}

	/**
	 * モードコンポーネント追加処理
	 * @param component モードコンポーネント
	 */
	public addModeComponet(component: WprBaseModeComponent<any>): void {
		this.m_ModeComponentList.push(component);
	}

	/**
	 * スコープモデルステータス設定
	 * @param model データ
	 */
	public setScopeModelState(model: any): void {
		if (this.isMount === false)
			return;
		this.m_Component.setState({
			scopeModel: model
		});
	}

	/**
	 * スコープモードステータス設定
	 * @param mode データ
	 */
	public setScopeModeState(mode: any): void {
		if (this.isMount === false)
			return;
		this.m_Component.setState({
			scopeMode: mode
		});
		this.updateComponentMode();
	}

	/**
	 * グローバルモデルステータス設定
	 * @param model モデル
	 */
	public setGlobalModelState(model: any): void {
		if (this.isMount === false)
			return;
		this.m_Component.setState({
			globalModel: model
		});
	}

	/**
	 * グローバルモードステータス設定
	 * @param mode データ
	 */
	public setGlobalModeState(mode: any): void {
		if (this.isMount === false)
			return;
		this.m_Component.setState({
			globalMode: mode
		});
		this.updateComponentMode();
	}

	/**
	 * スコープデータステータス取得
	 * @returns スコープデータ
	 */
	public getScopeModelState(): any {
		if (this.getScopeInfo() != null)
			return this.getScopeInfo().getScopeModelState();
		return {};
	}

	/**
	 * スコープモードステータス取得
	 * @returns スコープモード
	 */
	public getScopeModeState(): any {
		if (this.getScopeInfo() != null)
			return this.getScopeInfo().getScopeModeState();
		return {};
	}

	/**
	 * グローバルモデルステータス取得
	 */
	public getGlobalModelState(): any {
		if (this.m_GlobalScopeInfo != null)
			return this.m_GlobalScopeInfo.getScopeModelState();
		return {};
	}

	/**
	 * グローバルモードステータス取得
	 * @returns グローバルモード
	 */
	public getGlobalModeState(): any {
		if (this.m_GlobalScopeInfo != null)
			return this.m_GlobalScopeInfo.getScopeModeState();
		return {};
	}

	/**
	 * モードリストデータ設定
	 * @param listName リスト名
	 * @param listData リストデータ
	 */
	public setViewModeListData(listName: string, listData: Array<any>): void {
		super.setViewModeListData(listName, listData);
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.setViewModeListData(listName, listData);
		});
	}

	/**
	 * ビュー表示モード処理
	 */
	public showMode(): void {
		super.showMode();
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.showMode();
		});
		this.updateComponentMode();
	}

	/**
	 * ビューモード更新処理
	 */
	public updateMode(isClear?: boolean): void {
		super.updateMode(isClear);
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.updateMode(isClear);
		});
		this.updateComponentMode();
	}

	/**
	 * コンポーネントモード更新処理
	 */
	public updateComponentMode(): void {
		this.m_ModeComponentList.forEach(cmode => {
			let visible = false;
			for(const minfo of cmode.modeInfoList) {
				if (this.checkComponentMode(minfo.viewModeName, minfo.mode) === true ||
					this.checkViewModeData(minfo.viewModeName, minfo.mode) === true) {
					visible = true;
					break;
				}
			}
			if (cmode.props.invisible === true)
				visible = !visible;
			cmode.setVisible(visible);
		});
		for(const cinfo of this.m_ControlInfoMap.getControlInfoList()) {
			if (cinfo.config.enableMode)
				cinfo.updateComponentMode();
		}
	}

	/**
	 * スイッチコンポーネント設定
	 * @param sw スイッチコンポーネント
	 */
	public setSwitchComponet(sw: WprSwitch): void {
		this.FW.view.setSwitchComponet(sw);
	}
	// --------------------------------------------------------------------------

	// html使用メソッド	  --------------------------------------------------------
	/**
	 * ValueMapから候補リスト取得
	 * @param name コントロール名
	 * @param id ValueMapID
	 * @returns Key-Valueリスト
	 */
	public vm(name: string, id: string, row?: WprRowInfo): WprKeyValue[] {
		let list = this.FW.model.getValueList(id, false);
		if (list != null) {
			if (row) {
				list = this.onResetListValueMap(name, id, row, list);
				this.m_SubViewMap.forEach((subView, key, map) => {
					list = subView.onResetListValueMap(name, id, row, list);
				});
			}
			else {
				list = this.onResetValueMap(name, id, list);
				this.m_SubViewMap.forEach((subView, key, map) => {
					list = subView.onResetValueMap(name, id, list);
				});
			}
		}
		if (this.m_KeyValueMap.has(id) === false)
			this.m_KeyValueMap.set(id, new WprKeyValueMap());
		return this.m_KeyValueMap.get(id).getKeyValueList(list);
	}

	/**
	 * Null選択付きのValueMapから候補リスト取得
	 * @param name コントロール名
	 * @param id ValueMapID
	 * @returns Key-Valueリスト
	 */
	/* 廃止
	public vmn(name: string, id: string, row?: WprRowInfo): WprKeyValue[] {
		return this.vm(name, id, true);
	}
	*/
	// --------------------------------------------------------------------------

	// リスト関連 メソッド  -------------------------------------------------------
	/**
	 * リストデータ設定処理
	 * @param listName リスト名
	 * @param listData リストデータ
	 */
	public setListData(listName: string, listData: Array<any>): void {
		let ret = this.listInfoMap.setListData(listName, listData);
		this.m_SubViewMap.forEach((subView, key, map) => {
			if (ret === false)
				ret = subView.listInfoMap.setListData(listName, listData);
		});
		if (ret === true) {
			this.m_Component.setState({
				listData: this.getListDataState()
			});
		}
		else {
			this.addErrorLog(`setListData：リスト名に誤りがあります。[${listName}]`);
		}
	}

	/**
	 * リストデータ更新処理
	 * @param listName 
	 */
	public updateListData(listName: string): void {
		if (listName !== undefined && this.listInfoMap.getListInfo(listName) === null) {
			this.addErrorLog(`refreshListView：リスト名に誤りがあります。[${listName}]`);
		}
		else {
			this.m_Component.setState({
				listData: this.getListDataState()
			});
		}
	}

	/**
	 * リストデータをビューに反映する
	 * @param listName リスト名
	 * @param isErrorCheck エラーチェックフラグ
	 */
	public refreshListView(listName?: string, isErrorCheck: boolean = true): void {
		let ret = this.listInfoMap.refreshListView(listName);
		this.m_SubViewMap.forEach((subView, key, map) => {
			if (ret === false || listName === undefined)
				ret = subView.listInfoMap.refreshListView(listName);
		});
		if (isErrorCheck === true && ret === false && listName !== undefined)
			this.addErrorLog(`refreshListView：リスト名に誤りがあります。[${listName}]`);
	}

	/**
	 * リストデータをビューに反映する
	 * @param listName リスト名
	 * @param isErrorCheck エラーチェックフラグ
	 */
	public refreshListModel(listName?: string, isErrorCheck: boolean = true): void {
		let ret = this.listInfoMap.refreshListModel(listName);
		this.m_SubViewMap.forEach((subView, key, map) => {
			if (ret === false || listName === undefined)
				ret = subView.listInfoMap.refreshListModel(listName);
		});
		if (isErrorCheck === true && ret === false && listName !== undefined)
			this.addErrorLog(`refreshListModel：リスト名に誤りがあります。[${listName}]`);
		this.updateListData(listName);
	}

	/**
	 * リスト値をクリアする
	 * @param listName リスト名
	 * @param isErrorCheck エラーチェックフラグ
	 */
	public clearListValue(listName?: string, isErrorCheck: boolean = true): void {
		let ret = this.listInfoMap.clearListValue(listName);
		this.m_SubViewMap.forEach((subView, key, map) => {
			if (ret === false || listName === undefined)
				ret = subView.listInfoMap.clearListValue(listName);
		});
		if (isErrorCheck === true && ret === false && listName !== undefined)
			this.addErrorLog(`clearListValue：リスト名に誤りがあります。[${listName}]`);
	}

	/**
	 * リスト入力チェック
	 * @param listName リスト名
	 * @return trueの場合、入力済みでエラーなし
	 */
	public isInputList(listName?: string): boolean {
		if (this.listInfoMap.isInputList(listName) === false)
			return false;
		this.m_SubViewMap.forEach((subView, key, map) => {
			if (subView.listInfoMap.isInputList(listName) === false)
				return false;
		});
		return true;
	}

	/**
	 * リスト情報クリア処理
	 */
	public clearListInfo(): void {
		this.listInfoMap.clearListInfo();
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.listInfoMap.clearListInfo();
		});
	}
	// --------------------------------------------------------------------------

	// private メソッド  ---------------------------------------------------------
	/**
	 * サブビュー情報初期化
	 */
	private initSubViewInfo() {
		this.FW.model.getDecoNameList('SubView', this).forEach((sname) => {
			const subView = WprReflectUtil.getProperty(this, sname) as WprBaseSubView;
			if (subView) {
				if (this.m_SubViewMap.has(subView.name) === false) {
					subView.viewInfo = this;
					this.m_SubViewMap.set(subView.name, subView);
				}
				else {
					this.addErrorLog(`同一の@WprSubViewが既に登録されています。[${subView.name}][${subView.objectName}]`);
				}
			}
		});
	}

	/**
	 * コントロールリスト設定
	 */
	private setControlList(): void {
		this.m_ControlInfoMap.addControlList(this);
		this.m_SubViewMap.forEach((subView, key, map) => {
			this.m_ControlInfoMap.addControlList(subView, subView.name);
		});
	}

	/**
	 * ビューデータ取得
	 */
	private getViewDataState(): any {
		const data: any = {};
		this.m_ViewDataMap.forEach((value, name, map) => {
			data[name] = value;
		});
		return data;
	}

	/**
	 * ビューモード取得
	 */
	private getViewModeState(): any {
		const mode: any = {};
		this.m_ViewModeDataMap.forEach((value, name, map) => {
			mode[name] = value;
		});
		return mode;
	}

	/**
	 * リストデータステータス取得
	 * @returns リストデータステータス
	 */
	private getListDataState(): any {
		const listData: any = {};
		this.listInfoMap.setListDataState(listData);
		this.m_SubViewMap.forEach((subView, key, map) => {
			subView.listInfoMap.setListDataState(listData);
		});
		return listData;
	}

	/**
	 * スコープ情報設定
	 */
	public setScopeInfo(): void {
		this.globalScopeInfo = this.FW.scope.globalScopeInfo;
		if (this.getScopeInfo() != null) {
			this.getScopeInfo().setDIModelInfo(this, this.FW.model.getDecoNameMap('ScopeModel', this));
		}
		if (this.globalScopeInfo != null) {
			this.globalScopeInfo.setDIModelInfo(this, this.FW.model.getDecoNameMap('GlobalScopeModel', this));
		}
	}

	/**
	 * コンポーネントモードチェック処理
	 * @param viewMode ビューモード名
	 * @param mode モード
	 * @returns tureの場合、モードは含まれている
	 */
	private checkComponentMode(viewMode: string, mode: string): boolean {
		if (this.checkViewMode(viewMode, mode) === true)
			return true;
		for(const subView of this.m_SubViewMap.values()) {
			if (subView.checkViewMode(viewMode, mode) === true)
				return true;
		}
		if (this.getScopeInfo() != null) {
			if (this.getScopeInfo().checkMode(viewMode, mode) === true)
				return true;
		}
		if (this.m_GlobalScopeInfo != null) {
			if (this.m_GlobalScopeInfo.checkMode(viewMode, mode) === true)
				return true;
		}
		if (this.FW.getUrlParam(viewMode) != null)
			return true;
		return false;
	}

	/**
	 * ビューモードデータチェック
	 * @param viewMode ビューモード名
	 * @param mode モード
	 * @returns tureの場合、モードは含まれている
	 */
	private checkViewModeData(viewMode: string, mode: string): boolean {
		for (const key of this.m_ViewModeDataMap.keys()) {
			if (!viewMode || viewMode === key) {
				if (this.m_ViewModeDataMap.get(key) === mode)
					return true;
			}
		}
		return false;
	}

	/**
	 * ビューモード名チェック
	 * @param name ビューモード名
	 * @returns falseの場合、ビューモード名は重複している
	 */
	private checkModeName(name: string): boolean {
		if (this.checkViewModeName(name) === true)
			return true;
		for(const subView of this.m_SubViewMap.values()) {
			if (subView.checkViewModeName(name) === true)
				return true;
		}
		return false;
	}

	/**
	 * ビューモードステータス設定処理
	 */
	private setViewModeState() {
		if (this.isMount === false)
			return;
		this.m_Component.setState({
			data: this.getViewModeState()
		});
		this.updateComponentMode();
	}

	/**
	 * ビューモードデータ設定処理
	 * @param name: ビューモード名
	 * @param mode モード
	 * @returns falseの場合、モードは変化がない
	 */
	private setViewModeData(name: string, mode: any): boolean {
		if (this.m_ViewModeDataMap.has(name) === true && this.m_ViewModeDataMap.get(name) === mode)
			return false;
		this.m_ViewModeDataMap.set(name, mode);
		this.setViewModeState();
		return true;
	}

	/**
	 * 読取り専用コントロール再表示処理
	 * @param name コントロール名称
	 */
	private refreshReadOnlyControl(name?: string): void {
		WprControlInfo.isReadonlyRefresh = true;
		try {
			if (name === undefined)
				this.m_ControlInfoMap.refreshView(this, '@@all');
			else
				this.m_ControlInfoMap.refreshView(this, name);
			this.refreshListView();
		}
		finally {
			WprControlInfo.isReadonlyRefresh = false;
		}
	}

	/**
	 * スクロールイベント処理
	 */
	private onScroll(): void {
		window.setTimeout(this.onScrollEvent.bind(this), 10);
	}
	private onScrollEvent(): void {
		this.onScrollWindow(window.pageXOffset, window.pageYOffset);
	}

	/**
	 * リサイズイベント処理
	 */
	private onResize(): void {
		window.setTimeout(this.onResizeEvent.bind(this), 10);
	}
	private onResizeEvent(): void {
		this.onResizeWindow(window.innerWidth, window.innerHeight);
	}

	/**
	 * ウインドウイベント処理
	 */
	private startWindowEvent(): void {
		window.addEventListener('scroll', this.onScroll.bind(this), true);
		window.addEventListener('resize', this.onResize.bind(this), true);
		this.onScroll();
		this.onResize();
	}

	/**
	 * ウインドウリサイズイベント停止処理
	 */
	private stopWindowResizeEvent(): void {
		if (this.m_ResizeEvent === true) {
			window.removeEventListener('scroll', this.onScroll.bind(this));
			this.m_ResizeEvent = false;
		}
	}

	/**
	 * ウインドウスクロールイベント停止処理
	 */
	private stopWindowScrollEvent(): void {
		if (this.m_ScrollEvent === true) {
			window.removeEventListener('resize', this.onResize.bind(this));
			this.m_ScrollEvent = false;
		}
	}
	// --------------------------------------------------------------------------
}
